import React, { useEffect } from 'react';
import {connect} from 'react-redux';
import './errorStep.scss';
import Config from '../../../../../Config';
import gaParams from '../../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../../utilities/analytics/tracking';
import callIcon from '../../images/call-icon/call-icon.svg';
const ErrorStep = (props) => {

  useEffect(()=>{
    if (props.prevStep == 'update')
    {
      gaEvent(gaParams.ROUTER_ACTIVATION_WIZARD_ERROR_STEP_NO1_DISPLAY.category, 
        gaParams.ROUTER_ACTIVATION_WIZARD_ERROR_STEP_NO1_DISPLAY.eventType, 
        gaParams.ROUTER_ACTIVATION_WIZARD_ERROR_STEP_NO1_DISPLAY.eventParams);
    }
    else{
      gaEvent(gaParams.ROUTER_ACTIVATION_WIZARD_ERROR_STEP_NO2_DISPLAY.category, 
        gaParams.ROUTER_ACTIVATION_WIZARD_ERROR_STEP_NO2_DISPLAY.eventType, 
        gaParams.ROUTER_ACTIVATION_WIZARD_ERROR_STEP_NO2_DISPLAY.eventParams);
     }

  },[])

  async function dialCallCenter(){
    if (props.prevStep == 'update')
    {
      gaEvent(gaParams.ROUTER_ACTIVATION_WIZARD_ERROR_STEP_NO1_CLICK_CALL_CUSTOMER_SUPPORT_BUTTON.category, 
        gaParams.ROUTER_ACTIVATION_WIZARD_ERROR_STEP_NO1_CLICK_CALL_CUSTOMER_SUPPORT_BUTTON.eventType, 
        gaParams.ROUTER_ACTIVATION_WIZARD_ERROR_STEP_NO1_CLICK_CALL_CUSTOMER_SUPPORT_BUTTON.eventParams);
    }
    else{
      gaEvent(gaParams.ROUTER_ACTIVATION_WIZARD_ERROR_STEP_NO2_CLICK_CALL_CUSTOMER_SUPPORT_BUTTON.category, 
        gaParams.ROUTER_ACTIVATION_WIZARD_ERROR_STEP_NO2_CLICK_CALL_CUSTOMER_SUPPORT_BUTTON.eventType, 
        gaParams.ROUTER_ACTIVATION_WIZARD_ERROR_STEP_NO2_CLICK_CALL_CUSTOMER_SUPPORT_BUTTON.eventParams);
     }
  }

  return (<div className='error-step'>
        <div className='error-step-title'>רק שנייה,<br/> משהו כאן לא מסתדר</div>
        <div className='error-step-text'>במוקד התמיכה שלנו יידעו מה לעשות<br/>חייגו למוקד ונסייע לכם</div>
        <span className={`asBtn text-center sub-text d-block`}>
          <a style={{backgroundImage: callIcon.bg()}} href={`tel:${Config.technicalSupportPhone}`} onclick={()=>dialCallCenter()}>לשיחה עם נציג</a></span>
    </div>
  ) 
};

const mapStateToProps = (state) => {
  return{
    userData: state.authentication,
    prevStep: state.prevStep
  }
};

const mapDispatchToProps = {
};

export default connect(mapStateToProps,mapDispatchToProps)(ErrorStep);